module.exports = __webpack_public_path__ + "static/media/icon-task.2289de7f.svg";